import { usePreview } from '@dashboard/context/PreviewContext';
import { registerCaptureTarget } from '@dashboard/context/AIContext';
import useMountEffect from '@dashboard/hooks/useMountEffect';

// Lets the AI editor's view_page screenshot this preview. Keyed by page, so it re-registers for a new one.
export default function AIPreviewCapture({ pageId, containerRef }) {
  const [, dispatch] = usePreview();
  useMountEffect(() => registerCaptureTarget(pageId, { containerRef, dispatch }));
  return null;
}
